import {ROOT_PATH} from '../settings';

/**
 * Check a response on network level.
 * Redirect in case of status is HTTPForbidden or HTTPUnauthorized and
 * catch also all not handled server errors.
 * @param response: the response
 * @returns {*}
 */
function checkResponse(response) {
    if (response.status === 401 || response.status === 403){
        window.location = ROOT_PATH;
    }
    if (!response.ok) {
        const error = new Error(response.statusText);
        return Promise.reject(error);
    }
    return response.json();
}

/**
 * Before running callback_failure showing the error.
 * @param error: the raised error
 * @param callback_failure: callback that will be called if response is not ok
 * @returns {*}
 */
function handleFailingCall(error, callback_failure){
    console.log(error);
    callback_failure();
}

/**
 * General function to run a request
 * @param url: url to cal
 * @param method: the method like GET or POST
 * @param body_data: JS dict that will be send as json
 * @param callback_done: callback that will be called if all worked well
 * @param callback_failure: callback that will be called if response is not ok
 */
function fetchCall(url, method, body_data, callback_done, callback_failure) {
    let request_data = {
        method: method,
        credentials: 'include',
        cache: 'no-cache',
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    };

    if (body_data){
        request_data.body = JSON.stringify(body_data);
    }

    fetch(url, request_data)
        .then(response => checkResponse(response))
        .then(data => callback_done(data, callback_failure))
        .catch(error => handleFailingCall(error, callback_failure));
}

/**
 * General function to run a GET request
 * @param url: url to cal
 * @param callback_done: callback that will be called if all worked well
 * @param callback_failure: callback that will be called if response is not ok
 */
export function getCall(url, callback_done, callback_failure) {
    fetchCall(url, 'GET', null, callback_done, callback_failure);
}

/**
 * General function to run a POST request
 * @param url: url to cal
 * @param body_data: JS dict that will be send as json
 * @param callback_done: callback that will be called if all worked well
 * @param callback_failure: callback that will be called if response is not ok
 */
export function postCall(url, body_data, callback_done, callback_failure) {
    fetchCall(url, 'POST', body_data, callback_done, callback_failure);
}

/**
 * General function to upload a file
 * @param url: url to cal
 * @param file: file to upload
 * @param callback_done: callback that will be called if all worked well
 * @param callback_failure: callback that will be called if response is not ok
 */
export function fileUpload(url, file, callback_done, callback_failure) {
    let request_data = {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Accept": "*/*",
            "Content-Type": "*/*"
        },
        body: file
    };

    fetch(url, request_data)
        .then(response => checkResponse(response))
        .then(data => callback_done(data, callback_failure))
        .catch(error => handleFailingCall(error, callback_failure));
}
